import { AutogenModelEdiCrossRefTrailerType, AutogenRowEdiCrossRefTrailerType } from "./autogen/AutogenModelEdiCrossRefTrailerType";

export class ModelEdiCrossRefTrailerType extends AutogenModelEdiCrossRefTrailerType<RowEdiCrossRefTrailerType> {
	constructor() {
		super(RowEdiCrossRefTrailerType);
	}
}

export class RowEdiCrossRefTrailerType extends AutogenRowEdiCrossRefTrailerType {
}